import React from "react";
import { useState } from "react";
import "./Navbar.css";
// import { Link, NavLink } from "react-router-dom";

// import { Link ,useLocation} from "react-router-dom";
// import {Link} from "react-scroll"
// import logo from "../Images//logo.PNG";
// import { NavHashLink as Link } from "react-router-hash-link";
const NavBar = () => {
  // const [activeTab, setActiveTab] = useState(1); // set initial active tab

  // const handleTabClick = (tabIndex) => {
  //   setActiveTab(tabIndex);
  // };

  // const location = useLocation();

  // function isActiveTab(tabPath) {
  //   return location.pathname === tabPath;
  // }
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav className=" text-center items-center justify-center lg:top-[5px]">
      <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <a href="">
        <div className="flex flex-wrap text-start lg:ml-[-100px] lg:mt-[0px] mt-3">
          <img
            src="\Images\Logo\logo.png"
            alt=""
            className="lg:w-[40px] lg:h-[40px] w-[40px] h-[40px] lg:ml-[-290px] ml-[-140px]"
          />
          <p className="text-black mt-2 mx-2 font-semibold">Smcooks</p>
        </div>
      </a>
      <ul className={menuOpen ? "open" : ""}>
        <li>
          <a
            class="  mr-3  hover:bg-cyan-700 hover:text-white  rounded  scroll-smooth"
            activeclass="active"
            href="/"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            HOME
          </a>
        </li>
        <li>
          <a
            class="mr-3  hover:bg-cyan-700 hover:text-white  rounded scroll-smooth "
            activeclass="active"
            href="/about"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            ABOUT
          </a>
        </li>
        {/* <li>
          <a
            class="mr-3  hover:bg-cyan-700 hover:text-white  rounded scroll-smooth "
            activeclass="active"
            href="/services"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            Service
          </a>
        </li> */}
        <li>
          <a
            class="  mr-3  hover:bg-cyan-700 hover:text-white  rounded  scroll-smooth"
            activeclass="active"
            href="/menu"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            MENU
          </a>
        </li>
        <li>
          <a
            class="mr-4  hover:bg-cyan-700 hover:text-white  rounded scroll-smooth "
            activeclass="active"
            href="/staff"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            STAFF
          </a>
        </li>
        <li>
          <a
            class="mr-4  hover:bg-cyan-700 hover:text-white  rounded scroll-smooth "
            activeclass="active"
            href="/services"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            SERVICES
          </a>
        </li>
        <li>
          <a
            class="mr-3 hover:bg-cyan-700 hover:text-white rounded scroll-smooth"
            activeclass="active"
            href="/contact"
            spy="true"
            smooth="true"
            offset={-70}
            duration={500}
          >
            CONTACT
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
